export default function getDownloadedUrl(url: string): Promise<string> {
  return fetch(url)
    .then((res) => res.blob())
    .then((imageBlob) => {
      return URL.createObjectURL(imageBlob)
    })
}
